export default {
  SEARCH_BOX_PLACEHOLDER: 'Search for a product...',
};
